<template>
  <div v-on:click="$emit('onShortlinkClicked', shortlinktItem)" class="flex-item-wrapper">
    <div class="icon-contanier"><img :src="getIconURL" /></div>
    <div class="shortlint-title">{{ shortlinktItem.title }}</div>
</div>
</template>

<script>
export default {
  name: 'homeShortlink',
  props: {
    shortlinktItem: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    getIconURL () {
      return require(`../statics/icons/${this.shortlinktItem.icon}.svg`)
    }
  }
}

</script>

<style scoped>
.flex-item-wrapper {
    display: flex;
    align-content: center;
    flex-direction: column;
    position: static;
    max-width: 100%;
    height: 143px;
    left: calc(50% - 116.67px/2 - 132.67px);
    top: 0px;
    
    

/* Color / Grays / Gray-6 */

    background: #F1F1F7;
    border-radius: 20px;

/* Inside auto layout */

    flex: none;
    order: 0;
    flex-grow: 1;
}

.flex-item-wrapper:hover {
  background: #E5E6EE;
}

.icon-contanier {
  align-self: center;
  margin-top: 15px;
}
.shortlint-title {
  position: static;
  width: 80px;
  height: 26px;
  left: 0px;
  top: 80px;

  font-family: 'Lato';
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 16px;
/* identical to box height, or 173% */

  text-align: center;
  align-self: center;

/* Color / Grays / Nero | Text Color (AAA) */

  color: #161616;

}
</style>